/* eslint-disable camelcase */
export enum TileIds {
  ACTIVATE_MFA = 'activate-mfa',
  BOOK_CALL = 'book-call',
  EVENTS = 'events',
  GOOGLE_ANALYTICS = 'google-analytics',
  HIGHLIGHTS = 'highlights',
  SLACK = 'slack',
  TEAM = 'team',
  USER_ATTRIBUTES = 'user-attributes',
  ZAPIER = 'zapier',
  ERROR_REPORTING = 'error-reporting',
}

export interface StartPageContentDTO {
  guide_cards: string[];
  tiles: TileIds[];
  pro_tips: string[];
}

export interface StartPageContent {
  guideCards: string[];
  tiles: TileIds[];
  proTips: string[];
}
